import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import {
  loadNotificationsSuccess,
  loadNotificationsFailure,
  loadMessageReadRequest,
  loadNotifications as loadNotificationsRequest,
} from './actions';

export function* loadNotifications({ payload }: ReturnType<typeof loadNotificationsRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}consultaStatus&token=${state.auth.token}`,
      { inscricoesEstaduais: payload.inscricoesEstaduais }
    );

    yield put(loadNotificationsSuccess(response.data.mensagensNaoLidas));
  } catch (error: any) {
    yield put(loadNotificationsFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar oa notificações, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}

export function* loadMessageRead({ payload }: ReturnType<typeof loadMessageReadRequest>): any {
  try {
    const state = yield select();
    yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}atualizaMensagem&token=${state.auth.token}`,
      { protocolo: payload.protocolo }
    );
  } catch (error: any) {
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar notificações, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
